import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './AuthenticationPages/Login';
import SignUp from './AuthenticationPages/SignUp';
import RoleSelect from './AuthenticationPages/RoleSelect';
import Home from './PropertyManager/Home';
import Properties from './PropertyManager/Properties';
import AddProperty from './PropertyManager/AddProperty';
import PropertyDetails from './PropertyManager/PropertyDetails';
import Activity from './PropertyManager/Activity';
import Reports from './PropertyManager/Reports';
import ReportDetails from './PropertyManager/ReportDetails';
import Settings from './PropertyManager/Settings';
import Compare from './PropertyManager/Compare';
import WorkOrders from './PropertyManager/WorkOrders';
import WorkOrderDetails from './PropertyManager/WorkOrderDetails';
import BankConnection from './PropertyManager/BankConnection';
import Projection from './PropertyManager/Projection';
import StripeConnect from './PropertyManager/StripeConnect';
import ForgotPassword from "./AuthenticationPages/ForgotPassword";
import LandingPage from './DTecX/LandingPage';
import PrivacyPolicy from './DTecX/PrivacyPolicy';
import TermsOfService from './DTecX/TermsOfService';
import TenantLogin from './TenantPages/TenantLogin';
import TenantSignUp from './TenantPages/TenantSignUp';
import TenantHome from './TenantPages/TenantHome';
import TenantSettings from './TenantPages/TenantSettings';
import TenantPayments from './TenantPages/TenantPayments';
import TenantDocuments from './TenantPages/TenantDocuments';
import TenantMaintenance from './TenantPages/TenantMaintenance';
import TenantPaymentHistory from './TenantPages/TenantPaymentHistory';
import ToastContainer from './components/ToastContainer';


function App() {
  return (
    <Router>
      <div className="App">
        <ToastContainer />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/select-role" element={<RoleSelect />} />
          {/* Property Manager */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/home" element={<Home />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/properties/add" element={<AddProperty />} />
          <Route path="/properties/:id" element={<PropertyDetails />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/reports/:id" element={<ReportDetails />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/work-orders" element={<WorkOrders />} />
          <Route path="/work-orders/:id" element={<WorkOrderDetails />} />
          <Route path="/bank-connection" element={<BankConnection />} />
          <Route path="/projection" element={<Projection />} />
          <Route path="/stripe" element={<StripeConnect />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          {/* Tenant */}
          <Route path="/tenant/login" element={<TenantLogin />} />
          <Route path="/tenant/signup" element={<TenantSignUp />} />
          <Route path="/tenant/home" element={<TenantHome />} />
          <Route path="/tenant/settings" element={<TenantSettings />} />
          <Route path="/tenant/payments" element={<TenantPayments />} />
          <Route path="/tenant/documents" element={<TenantDocuments />} />
          <Route path="/tenant/maintenance" element={<TenantMaintenance />} />
          <Route path="/tenant/payment-history" element={<TenantPaymentHistory />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
